// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Specular_Internal_Incremental from "../Specular.Internal.Incremental/index.js";
import * as Specular_Internal_Incremental_Node from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular_Internal_Incremental_Optional from "../Specular.Internal.Incremental.Optional/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
import * as Specular_Internal_Queue from "../Specular.Internal.Queue/index.js";
var Event = function (x) {
    return x;
};
var Dynamic = function (x) {
    return x;
};
var Behavior = function (x) {
    return x;
};
var traceNode = function (handler) {
    return function (input) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.traceChanges(Effect_Uncurried.mkEffectFn1(handler), input);
            Specular_Internal_Incremental_Node.annotate(n, "trace");
            return n;
        });
    };
};
var traceEventIO = function (handler) {
    return function (v) {
        return traceNode(handler)(v);
    };
};
var traceDynIO = function (handler) {
    return function (v) {
        return traceNode(handler)(v);
    };
};
var $$switch = function (v) {
    return Event(Effect_Unsafe.unsafePerformEffect(function __do() {
        var n = Specular_Internal_Incremental["switch"](false, v, function (v1) {
            return v1;
        });
        Specular_Internal_Incremental_Node.annotate(n, "switch");
        return n;
    }));
};
var sampleAt = function (v) {
    return function (v1) {
        return Event(Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.sample(function (a, b) {
                return Specular_Internal_Incremental_Optional.some(b(a));
            }, v1, v);
            Specular_Internal_Incremental_Node.annotate(n, "sampleAt");
            return n;
        }));
    };
};
var readNode = function (node) {
    var handler = function (v) {
        return Data_Unit.unit;
    };
    return function __do() {
        Specular_Internal_Incremental.addObserver(node, handler);
        var value = Specular_Internal_Incremental_Node.get_value(node);
        Specular_Internal_Incremental.removeObserver(node, handler);
        return Specular_Internal_Incremental_Optional.fromSome(value);
    };
};
var readDynamic = function (dictMonadEffect) {
    return function (v) {
        return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
            var mark = Specular_Internal_Profiling.begin("readDynamic");
            var result = readNode(v)();
            Specular_Internal_Profiling.end(mark);
            return result;
        });
    };
};
var readBehavior = function (v) {
    return readNode(v);
};
var pull = function (dictMonadEffect) {
    return Effect_Class.liftEffect(dictMonadEffect);
};
var never = Specular_Internal_Incremental.readEvent(Effect_Unsafe.unsafePerformEffect(Specular_Internal_Incremental.newEvent));
var monadFRP = function (dictMonadEffect) {
    return function (dictMonadCleanup) {
        return {
            MonadEffect0: function () {
                return dictMonadEffect;
            },
            MonadCleanup1: function () {
                return dictMonadCleanup;
            }
        };
    };
};
var map2 = function (f) {
    return function (v) {
        return function (v1) {
            return Dynamic(Effect_Unsafe.unsafePerformEffect(function __do() {
                var n = Specular_Internal_Incremental.map2(Data_Function_Uncurried.mkFn2(f), v, v1);
                Specular_Internal_Incremental_Node.annotate(n, "map2 (" + (Specular_Internal_Incremental_Node.name(v) + (") (" + (Specular_Internal_Incremental_Node.name(v1) + ")"))));
                return n;
            }));
        };
    };
};
var leftmost = function (events) {
    return Event(Effect_Unsafe.unsafePerformEffect(function __do() {
        var n = Specular_Internal_Incremental.leftmost(Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return v;
        })(events));
        Specular_Internal_Incremental_Node.annotate(n, "leftmost");
        return n;
    }));
};
var globalEffectQueue = Effect_Unsafe.unsafePerformEffect(Specular_Internal_Queue["new"]);
var functorEvent = {
    map: function (f) {
        return function (v) {
            return Event(Effect_Unsafe.unsafePerformEffect(function __do() {
                var n = Specular_Internal_Incremental.mapOptional(function ($114) {
                    return Specular_Internal_Incremental_Optional.some(f($114));
                }, v);
                Specular_Internal_Incremental_Node.annotate(n, "mapEvent");
                return n;
            }));
        };
    }
};
var functorDynamic = {
    map: function (f) {
        return function (v) {
            return Dynamic(Effect_Unsafe.unsafePerformEffect(function __do() {
                var n = Specular_Internal_Incremental.map(f, v);
                Specular_Internal_Incremental_Node.annotate(n, "map " + Specular_Internal_Incremental_Node.name(v));
                return n;
            }));
        };
    }
};
var functorBehavior = functorDynamic;
var filterMapEvent = function (f) {
    return function (v) {
        return Event(Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.mapOptional((function () {
                var $115 = Data_Maybe.maybe(Specular_Internal_Incremental_Optional.none)(Specular_Internal_Incremental_Optional.some);
                return function ($116) {
                    return $115(f($116));
                };
            })(), v);
            Specular_Internal_Incremental_Node.annotate(n, "filterMapEvent");
            return n;
        }));
    };
};
var filterJustEvent = filterMapEvent(Control_Category.identity(Control_Category.categoryFn));
var filterEvent = function (f) {
    return function (v) {
        return Event(Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.mapOptional(function (x) {
                var $84 = f(x);
                if ($84) {
                    return Specular_Internal_Incremental_Optional.some(x);
                };
                return Specular_Internal_Incremental_Optional.none;
            }, v);
            Specular_Internal_Incremental_Node.annotate(n, "filterEvent");
            return n;
        }));
    };
};
var drainEffects = function () {
    return Specular_Internal_Queue.drain(globalEffectQueue, function (handler) {
        return handler();
    });
};
var stabilize = function __do() {
    var mark = Specular_Internal_Profiling.begin("Specular.stabilize");
    Specular_Internal_Incremental.stabilize();
    drainEffects();
    return Specular_Internal_Profiling.end(mark);
};
var newDynamic = function (dictMonadEffect) {
    return function (initial) {
        return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
            var $$var = Specular_Internal_Incremental.newVar(initial);
            Specular_Internal_Incremental_Node.annotate(Specular_Internal_Incremental.readVar($$var), "root Dynamic");
            var dynamic = Specular_Internal_Incremental.readVar($$var);
            return {
                dynamic: dynamic,
                read: readDynamic(Effect_Class.monadEffectEffect)(dynamic),
                set: function (x) {
                    return function __do() {
                        var name = Specular_Internal_Incremental_Node.get_name(Specular_Internal_Incremental.readVar($$var));
                        var mark = Specular_Internal_Profiling.begin("set " + name);
                        Specular_Internal_Incremental.setVar($$var, x);
                        stabilize();
                        return Specular_Internal_Profiling.end(mark);
                    };
                },
                modify: function (f) {
                    return function __do() {
                        var name = Specular_Internal_Incremental_Node.get_name(Specular_Internal_Incremental.readVar($$var));
                        var mark = Specular_Internal_Profiling.begin("modify " + name);
                        var x = Specular_Internal_Incremental_Node.valueExc(Specular_Internal_Incremental.readVar($$var));
                        Specular_Internal_Incremental.setVar($$var, f(x));
                        stabilize();
                        return Specular_Internal_Profiling.end(mark);
                    };
                }
            };
        });
    };
};
var newBehaviorEffect = function (initialValue) {
    return function __do() {
        var v = newDynamic(Effect_Class.monadEffectEffect)(initialValue)();
        return {
            behavior: v.dynamic,
            set: v.set
        };
    };
};
var newBehavior = function (dictMonadEffect) {
    return function (initialValue) {
        return Effect_Class.liftEffect(dictMonadEffect)(newBehaviorEffect(initialValue));
    };
};
var newEvent = function (dictMonadEffect) {
    return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
        var evt = Specular_Internal_Incremental.newEvent();
        Specular_Internal_Incremental_Node.annotate(Specular_Internal_Incremental.readEvent(evt), "root Event");
        return {
            event: Specular_Internal_Incremental.readEvent(evt),
            fire: function (x) {
                return function __do() {
                    var name = Specular_Internal_Incremental_Node.get_name(Specular_Internal_Incremental.readEvent(evt));
                    var mark = Specular_Internal_Profiling.begin("fire " + name);
                    Specular_Internal_Incremental.triggerEvent(evt, x);
                    stabilize();
                    return Specular_Internal_Profiling.end(mark);
                };
            }
        };
    });
};
var current = Behavior;
var tagDyn = function (dyn) {
    return function (event) {
        return sampleAt(Data_Functor.voidRight(functorEvent)(Control_Category.identity(Control_Category.categoryFn))(event))(current(dyn));
    };
};
var changed = function (v) {
    return v;
};
var changed_ = (function () {
    var $117 = Data_Functor["void"](functorDynamic);
    return function ($118) {
        return changed($117($118));
    };
})();
var attachDynWith = function (f) {
    return function (dyn) {
        return function (event) {
            return sampleAt(Data_Functor.map(functorEvent)(Data_Function.flip(f))(event))(current(dyn));
        };
    };
};
var applyDynamic = {
    apply: function (v) {
        return function (v1) {
            return Dynamic(Effect_Unsafe.unsafePerformEffect(function __do() {
                var n = Specular_Internal_Incremental.map2(Data_Function_Uncurried.mkFn2(Data_Function.apply), v, v1);
                Specular_Internal_Incremental_Node.annotate(n, "apply (" + (Specular_Internal_Incremental_Node.name(v) + (") (" + (Specular_Internal_Incremental_Node.name(v1) + ")"))));
                return n;
            }));
        };
    },
    Functor0: function () {
        return functorDynamic;
    }
};
var bindDynamic = {
    bind: function (v) {
        return function (f) {
            return Dynamic(Effect_Unsafe.unsafePerformEffect(function __do() {
                var n = Specular_Internal_Incremental.bind_(v, function (x) {
                    var v1 = f(x);
                    return v1;
                });
                Specular_Internal_Incremental_Node.annotate(n, "bindDynamic");
                return n;
            }));
        };
    },
    Apply0: function () {
        return applyDynamic;
    }
};
var bindBehavior = bindDynamic;
var semigroupDynamic = function (dictSemigroup) {
    return {
        append: Control_Apply.lift2(applyDynamic)(Data_Semigroup.append(dictSemigroup))
    };
};
var applyBehavior = applyDynamic;
var applicativeDynamic = {
    pure: function (x) {
        return Dynamic(Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.constant(x);
            Specular_Internal_Incremental_Node.annotate(n, "pure");
            return n;
        }));
    },
    Apply0: function () {
        return applyDynamic;
    }
};
var heytingAlgebraDynamic = function (dictHeytingAlgebra) {
    return {
        tt: Control_Applicative.pure(applicativeDynamic)(Data_HeytingAlgebra.tt(dictHeytingAlgebra)),
        ff: Control_Applicative.pure(applicativeDynamic)(Data_HeytingAlgebra.ff(dictHeytingAlgebra)),
        implies: Control_Apply.lift2(applyDynamic)(Data_HeytingAlgebra.implies(dictHeytingAlgebra)),
        conj: Control_Apply.lift2(applyDynamic)(Data_HeytingAlgebra.conj(dictHeytingAlgebra)),
        disj: Control_Apply.lift2(applyDynamic)(Data_HeytingAlgebra.disj(dictHeytingAlgebra)),
        not: Data_Functor.map(functorDynamic)(Data_HeytingAlgebra.not(dictHeytingAlgebra))
    };
};
var monadDynamic = {
    Applicative0: function () {
        return applicativeDynamic;
    },
    Bind1: function () {
        return bindDynamic;
    }
};
var monoidDynamic = function (dictMonoid) {
    return {
        mempty: Control_Applicative.pure(applicativeDynamic)(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupDynamic(dictMonoid.Semigroup0());
        }
    };
};
var applicativeBehavior = applicativeDynamic;
var monadBehavior = {
    Applicative0: function () {
        return applicativeBehavior;
    },
    Bind1: function () {
        return bindBehavior;
    }
};
var annotated = function (name) {
    return function (v) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            Specular_Internal_Incremental_Node.annotate(v, name);
            return v;
        });
    };
};
var annotate = function (dictMonadEffect) {
    return function (v) {
        return function (name) {
            return Effect_Class.liftEffect(dictMonadEffect)(function () {
                return Specular_Internal_Incremental_Node.annotate(v, name);
            });
        };
    };
};
var _subscribeNode = function (handler, node) {
    var h = function (value) {
        return Specular_Internal_Queue.enqueue(globalEffectQueue, handler(value));
    };
    Specular_Internal_Incremental.addObserver(node, h);
    return function () {
        return Specular_Internal_Incremental.removeObserver(node, h);
    };
};
var subscribeNode = function (dictMonadEffect) {
    return function (dictMonadCleanup) {
        return function (handler) {
            return function (event) {
                return Control_Bind.bind((dictMonadCleanup.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(function () {
                    return _subscribeNode(handler, event);
                }))(function (unsub) {
                    return Control_Monad_Cleanup.onCleanup(dictMonadCleanup)(unsub);
                });
            };
        };
    };
};
var foldDyn = function (dictMonadFRP) {
    return function (f) {
        return function (initial) {
            return function (v) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(function __do() {
                    var n = Specular_Internal_Incremental.fold(function (a, b) {
                        return Specular_Internal_Incremental_Optional.some(f(a)(b));
                    }, initial, v);
                    Specular_Internal_Incremental_Node.annotate(n, "foldDyn");
                    return n;
                }))(function (n) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(function (v1) {
                        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                    })(n))(function () {
                        return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(n);
                    });
                });
            };
        };
    };
};
var holdDyn = function (dictMonadFRP) {
    return foldDyn(dictMonadFRP)(function (x) {
        return function (v) {
            return x;
        };
    });
};
var foldDynMaybe = function (dictMonadFRP) {
    return function (f) {
        return function (initial) {
            return function (v) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(function __do() {
                    var n = Specular_Internal_Incremental.fold(function (a, b) {
                        return Data_Maybe.maybe(Specular_Internal_Incremental_Optional.none)(Specular_Internal_Incremental_Optional.some)(f(a)(b));
                    }, initial, v);
                    Specular_Internal_Incremental_Node.annotate(n, "foldDynMaybe");
                    return n;
                }))(function (n) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(function (v1) {
                        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                    })(n))(function () {
                        return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(n);
                    });
                });
            };
        };
    };
};
var holdUniqDynBy = function (dictMonadFRP) {
    return function (eq) {
        return foldDynMaybe(dictMonadFRP)(function ($$new) {
            return function (old) {
                var $104 = eq($$new)(old);
                if ($104) {
                    return Data_Maybe.Nothing.value;
                };
                return new Data_Maybe.Just($$new);
            };
        });
    };
};
var uniqDynBy = function (dictMonadFRP) {
    return function (eq) {
        return function (v) {
            var handler = function (v1) {
                return Data_Unit.unit;
            };
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(function __do() {
                Specular_Internal_Incremental.addObserver(v, handler);
                return Specular_Internal_Incremental_Node.valueExc(v);
            }))(function (initialValue) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(holdUniqDynBy(dictMonadFRP)(eq)(initialValue)(changed(v)))(function (uniqDyn_) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(function () {
                        return Specular_Internal_Incremental.removeObserver(v, handler);
                    }))(function () {
                        return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(uniqDyn_);
                    });
                });
            });
        };
    };
};
var uniqDyn = function (dictMonadFRP) {
    return function (dictEq) {
        return uniqDynBy(dictMonadFRP)(Data_Eq.eq(dictEq));
    };
};
var latestJust = function (dictMonadFRP) {
    return function (dyn) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(readDynamic(dictMonadFRP.MonadEffect0())(dyn))(function (currentValue) {
            return foldDynMaybe(dictMonadFRP)(function ($$new) {
                return function (v) {
                    return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Maybe.Just.create)($$new);
                };
            })(currentValue)(changed(dyn));
        });
    };
};
var subscribeDyn = function (dictMonadFRP) {
    return function (handler) {
        return function (v) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(function __do() {
                var evt = Specular_Internal_Incremental.newEvent();
                Specular_Internal_Incremental_Node.annotate(Specular_Internal_Incremental.readEvent(evt), "subscribeDyn");
                return evt;
            }))(function (evt) {
                return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(function (x) {
                    return function __do() {
                        var value = handler(x)();
                        Specular_Internal_Incremental.triggerEvent(evt, value);
                        return stabilize();
                    };
                })(v))(function () {
                    return Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(function __do() {
                        var currentValue = Specular_Internal_Incremental_Node.valueExc(v);
                        var initialResult = handler(currentValue)();
                        Specular_Internal_Incremental_Node.set_value(Specular_Internal_Incremental.readEvent(evt), Specular_Internal_Incremental_Optional.some(initialResult));
                        return Specular_Internal_Incremental.readEvent(evt);
                    });
                });
            });
        };
    };
};
var subscribeDyn_ = function (dictMonadFRP) {
    return function (handler) {
        return function (v) {
            return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(handler)(v))(function () {
                return Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(function __do() {
                    var currentValue = Specular_Internal_Incremental_Node.valueExc(v);
                    return Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(handler(currentValue))();
                });
            });
        };
    };
};
var subscribeEvent_ = function (dictMonadEffect) {
    return function (dictMonadCleanup) {
        return function (handler) {
            return function (v) {
                return subscribeNode(dictMonadEffect)(dictMonadCleanup)(handler)(v);
            };
        };
    };
};
var _subscribeEvent = function (handler, v) {
    return _subscribeNode(handler, v);
};
export {
    never,
    leftmost,
    filterEvent,
    filterMapEvent,
    filterJustEvent,
    pull,
    sampleAt,
    readBehavior,
    current,
    changed,
    changed_,
    $$switch as switch,
    tagDyn,
    attachDynWith,
    latestJust,
    readDynamic,
    newDynamic,
    holdDyn,
    foldDyn,
    foldDynMaybe,
    holdUniqDynBy,
    uniqDynBy,
    uniqDyn,
    newEvent,
    newBehavior,
    subscribeEvent_,
    subscribeDyn_,
    subscribeDyn,
    _subscribeEvent,
    traceEventIO,
    traceDynIO,
    annotate,
    annotated,
    map2,
    functorBehavior,
    applyBehavior,
    applicativeBehavior,
    bindBehavior,
    monadBehavior,
    functorEvent,
    functorDynamic,
    applyDynamic,
    applicativeDynamic,
    bindDynamic,
    monadDynamic,
    monadFRP,
    heytingAlgebraDynamic,
    semigroupDynamic,
    monoidDynamic
};
//# sourceMappingURL=index.js.map
